import { HIDE_TOAST, showToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import type { ThunkDispatchCommon } from "single-spa/store/types";

export const exportToExcelToastThunk = (text: string) => {
    return (dispatch: ThunkDispatchCommon) => {
        const timestamp = Date.now();

        dispatch(
            showToast(
                getToastItemComponent({
                    text,
                    onClick: () =>
                        dispatch({
                            type: HIDE_TOAST,
                            toast: {
                                timestamp,
                            },
                        }),
                }),
                "success",
                timestamp,
            ),
        );
    };
};
